// Captures a ?ref=CODE query param into localStorage on first landing
// (first-touch only - never overwrites an existing stored code), so it
// survives the redirect out to Keycloak's hosted signup and back, and can
// be read again whenever the visitor eventually creates their facility
// (FacilityForm_v2.jsx), even if that happens weeks later.
const STORAGE_REFERRAL_CODE = 'qrproof:referralCode';

export function captureReferralCode() {
  try {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref && !localStorage.getItem(STORAGE_REFERRAL_CODE)) {
      localStorage.setItem(STORAGE_REFERRAL_CODE, ref);
    }
  } catch {
    // localStorage unavailable (private browsing, disabled storage) - the
    // referral link simply won't be tracked for this visitor, not fatal.
  }
}

export function getStoredReferralCode() {
  try {
    return localStorage.getItem(STORAGE_REFERRAL_CODE) || null;
  } catch {
    return null;
  }
}
